import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class AppRedirectService {
private readonly showSpinnerSubject = new BehaviorSubject<boolean>(false);
  readonly showSpinner$ = this.showSpinnerSubject.asObservable();
  appStoreLink: string = '';
  playStoreLink: string = '';
  deepLinkUrl: string = '';
  private readonly renderer: Renderer2;
  appStoreRedirectionLink: any;

  constructor( private readonly translationService: TranslationService, readonly rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public getSmartBannerLinks(){
    this.playStoreLink = this.translationService.cpSecrets.playStoreLink;
    this.appStoreLink = this.translationService.cpSecrets.appStoreLink;
    this.deepLinkUrl = this.translationService.cpSecrets.deepLinkUrl;
    this.appStoreRedirectionLink = this.translationService.cpSecrets.appStoreLink;
  }


  public detectAppleDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor;
    return /Mac|iPhone|iPad/.test(userAgent);
  }

  public triggerGoToApp(): void {
    this.getSmartBannerLinks();

    this.showSpinnerSubject.next(true);

    const redirectUrl = this.detectAppleDevice()
      ? this.playStoreLink
      : this.appStoreLink;

    window.location.href = this.deepLinkUrl;

    let appOpened = false;

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') {
        appOpened = true;
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        this.showSpinnerSubject.next(false);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    setTimeout(() => {
      if (!appOpened && redirectUrl) {
        window.location.href = redirectUrl;
        this.showSpinnerSubject.next(false);
      }
    }, 3000);

  }

  public closeSpinner(): void {
    this.showSpinnerSubject.next(false);
  }

  checkBannerPresence(): boolean {
    return !!this.renderer.selectRootElement('.banner-area', true);
  }
}
